import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

const InStockIcon = props => {
  const { title, width, height, toneDown } = props;
  return (
    <svg
      className={styles['in-stock'].withModifier({ 'tone-down': toneDown })}
      height={height}
      width={width}
      viewBox="0 0 29 11"
    >
      {title && <title>{title}</title>}
      <path
        d="M20.2 6.5L26.6 0.1 28.7 2.2 20.2 10.7 19.2 9.7 15.3 5.8 17.4 3.7 20.2 6.5ZM1 0L4 0 4 3 1 3 1 0ZM5 0L8 0 8 3 5 3 5 0ZM0 4L3 4 3 7 0 7 0 4ZM4 4L7 4 7 7 4 7 4 4ZM8 4L11 4 11 7 8 7 8 4ZM0 8L3 8 3 11 0 11 0 8ZM4 8L7 8 7 11 4 11 4 8ZM8 8L11 8 11 11 8 11 8 8Z"
        fill="#55AB42"
      />
    </svg>
  );
};

const { string, number, bool } = PropTypes;
InStockIcon.propTypes = {
  title: string,
  height: number,
  width: number,
  toneDown: bool,
};

InStockIcon.defaultProps = {
  height: 12,
  width: 30,
  title: undefined,
  toneDown: false,
};

export default InStockIcon;
